import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { getToken, onUnauthorized } from "@/lib/api";
import Login from "@/pages/Login";

// Lazy load pages for faster initial render
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const CreateOrder = lazy(() => import("@/pages/CreateOrder"));
const OrderDetail = lazy(() => import("@/pages/OrderDetail"));
const Comisionistas = lazy(() => import("@/pages/Comisionistas"));
const EditOrder = lazy(() => import("@/pages/EditOrder"));
const Config = lazy(() => import("@/pages/Config"));
const Clientes = lazy(() => import("@/pages/Clientes"));

// Loading component that shows immediately
function LoadingScreen() {
  return (
    <div className="min-h-screen bg-zinc-100 flex flex-col items-center justify-center">
      <img 
        src="https://customer-assets.emergentagent.com/job_service-tracker-265/artifacts/k1nm2r2h_D_NQ_NP_880992-MLA83949983996_042025-O.webp" 
        alt="Logo"
        className="w-20 h-20 object-contain mb-4"
      />
      <div className="flex items-center gap-2 text-zinc-600">
        <Loader2 className="w-5 h-5 animate-spin text-orange-500" />
        <span className="font-medium">Cargando...</span>
      </div>
    </div>
  );
}

function App() {
  const [authed, setAuthed] = useState(!!getToken());

  useEffect(() => {
    onUnauthorized.handler = () => {
      setAuthed(false);
      toast.error("Sesión finalizada. Ingrese la clave nuevamente.");
    };
    return () => { onUnauthorized.handler = null; };
  }, []);

  return (
    <div className="App">
      <Toaster />
      {!authed ? (
        <Login onSuccess={() => setAuthed(true)} />
      ) : (
        <BrowserRouter>
          <Suspense fallback={<LoadingScreen />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/create" element={<CreateOrder />} />
              <Route path="/order/:orderId" element={<OrderDetail />} />
              <Route path="/order/:orderId/edit" element={<EditOrder />} />
              <Route path="/comisionistas" element={<Comisionistas />} />
              <Route path="/config" element={<Config />} />
              <Route path="/clientes" element={<Clientes />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
